import React  from 'react';
import ImageUpload from "./floorplans";

export default function Plan() {
  return (<ImageUpload />)
}
